<template>
  <div class="container-fluid">
    <navigation-admin></navigation-admin>
    <div class="row row-fluid wrapper-flexbox">
      <sidebar-admin></sidebar-admin>
      <form class="col-sm-10 admin-background-shadow overflow" @submit="update">
        <product-navbar></product-navbar>
        <div class="tab-content" novalidate>
          <div id="General" class="tab-pane fade in active">
            <product-general-edit v-ref:general :form="current_product_edit"></product-general-edit>
          </div>
          <div id="Shipping" class="tab-pane fade">
            <product-shipping-edit v-ref:shipping :form="current_product_edit"></product-shipping-edit>
          </div>
          <div id="Complements" class="tab-pane fade">
            <table-complement-edit v-ref:complement :form="current_product_edit"></table-complement-edit>
          </div>
        </div>
      </form>
    </div>
  </div>

  <loader-full v-if="is_submited"></loader-full>
</template>

<style scoped>
  .tab-content{
    padding-left: 20px;
  }
  .admin-background-shadow{
      background: #f4f4f8;
  }
  section{
    width: 100%;
  }
</style>

<script>
  import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
  import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
  import productNavbar from '../../components/Admin/Admin-product-navbar.vue';
  import productGeneralEdit from '../../components/Admin/Admin-product-general-edit.vue';
  import productShippingEdit from '../../components/Admin/Admin-products-shipping-edit.vue';
  import tableComplementEdit from '../../components/Admin/Admin-product-complement-edit.vue';
  import LoaderFull from '../../components/Loader-full.vue';
  import { updateProduct, setCurrentProductEdit } from '../../store/actions';
  import { router } from '../../routes/routes';

  export default {
    // ------ DATA ------

    data() {
      return {
        form: {},
        is_submited: false
      };
    },

    // ------ VUEX ------

    vuex: {
      getters: {
        user: state => state.current_user,
        current_product_edit: state => {
        	return state.current_product_edit
       	}
      },
      actions: {
        updateProduct,
        setCurrentProductEdit
      }
    },

    // ------ COMPONENTS ------

    components: {
      navigationAdmin,
      sidebarAdmin,
      productNavbar,
      productGeneralEdit,
      productShippingEdit,
      tableComplementEdit,
      LoaderFull
    },

    // ------ METHODS ------

    methods: {
      update(e) {
        e.preventDefault();

        for (var k in this.$refs) {
          for (var kf in this.$refs[k].form) {
            this.form[kf] = this.$refs[k].form[kf];
          }
        }

        // set the category, if has a subcategory set this.
		if (this.form.subcategory_id) {
			this.form.category_id = this.form.subcategory_id;
		}

        this.is_submited = true;
        // Call the actions to create the product.
        this.updateProduct(this.user, this.form, this);
      },

      getProduct(id) {
        this.setCurrentProductEdit(id);
      },

      changeProduct() {
        router.afterEach(transition => {
          if (this.$route.name == 'admin_product_edit') {
            this.getProduct(this.$route.params.id);
          }
        });
      }
    },

    // ------ READY ------

    ready() {
      this.getProduct(this.$route.params.id);
      this.changeProduct();
    }
  }
</script>


// WEBPACK FOOTER //
// Admin-products-edit.vue?1fdfa4bf